<template>
  <div class="container-fluid">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Manager'
}
</script>

<style></style>
